module.exports = __webpack_public_path__ + "static/media/Team-Mingtong.57933470.jpg";